import Vue from 'vue'
import './hooks' // This must be imported before any component
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
import 'vis/dist/vis.min.css'
import 'mdi/css/materialdesignicons.min.css'

Vue.use(Vuetify)

import App from './App.vue'
import router from './router'
import { store } from './store'

Vue.config.productionTip = false

import config from './config'
config.SERVER_URL = process.env.SERVER_URL!

store.dispatch('auth/refresh')

// tslint:disable-next-line:no-unused-expression
new Vue({
    router,
    el: '#app',
    render: h => h(App),
    store,
})



// WEBPACK FOOTER //
// ./src/main.ts